/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-msg[_ngcontent-%COMP%]{color:#d00303;font-weight:700}"];
export { styles as styles };
